import { deepClone } from '../utils/object';
import { fetchData } from '../utils/async';

export const CHANGE_DEVICE = 'CHANGE_DEVICE';
export const COOKIE_CONSENT = 'COOKIE_CONSENT';

export const INIT = 'INIT';
export const SITE_INIT = 'SITE_INIT';
export const SET_QUERY = 'SET_QUERY';

export const OPEN_MENU = 'OPEN_MENU';

export const UPDATE_CART = 'UPDATE_CART';

export const INPUT_FIELD_UPDATE = 'INPUT_FIELD_UPDATE';
export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const UPDATE_EVENT_DETAILS_ERRORS = 'UPDATE_EVENT_DETAILS_ERRORS';

export const PARTICIPANTS_REGISTERED = 'PARTICIPANTS_REGISTERED';
export const PARTICIPANTS_ERROR = 'PARTICIPANTS_ERROR';

export const INDEX_SORT = 'INDEX_SORT';

/*
	USER SETTINGS
*/
export const changeDevice = (isMobile) => ({ type: CHANGE_DEVICE, isMobile });
export const cookieConsent = (consent) => ({ type: COOKIE_CONSENT, consent });
export const clientInit = () => ({ type: 'CLIENT_INIT' });

/*
	INTERACTION EVENTS
*/

export const openMenu = () => ({ type: OPEN_MENU });

export const updateCart = (actions) => ({ type: UPDATE_CART, ...actions });

export const goToPage = (path) => (dispatch, getState) => {
	const language = getState().environment.setup.language;
	const extra = {};
	const pathSections = path.split('/').reduce((acc, section) => {
		if (section !== '' && section !== language) {
			if (section.indexOf('#') !== -1) {
				extra.hash = section.slice(section.indexOf('#') + 1);
				section = section.slice(0, section.indexOf('#'));
			}
			return [...acc, section];
		}
		return acc;
	}, []);

	if (pathSections[0] === 'selection' && pathSections.length === 1) {
		return dispatch({ type: 'SELECTION', payload: { language } });
	}
	if (pathSections.length === 0) {
		return dispatch({ type: 'START', payload: { language } });
	}
	return dispatch({ type: 'CATEGORY_PRODUCT_PAGE', payload: { language, path: pathSections.join('/'), ...extra } });
};

/*
	FORM EVENTS
*/

export const inputFieldUpdate = (field, section, value, valid) => ({ type: INPUT_FIELD_UPDATE, field, section, value, valid });

export const formSubmitted = (section) => ({ type: FORM_SUBMITTED, section });

/*
	TRANSITION EVENTS
*/

export const removeNotification = (notificationType, notificationName) => ({ type: REMOVE_NOTIFICATION, notificationType, notificationName });

/*
	FILTER ACTIONS
*/

export const updateFilter = (filterArray, force = false) => ({ type: 'FILTER', filterArray, force });

export const clearFilter = () => ({ type: 'CLEAR_FILTER' });

export const clearSort = () => ({ type: 'CLEAR_SORT' });

export const resetFilter = () => ({ type: 'RESET_FILTER' });

export const searchInput = (text) => ({ type: 'SEARCH', text });

/*
	PAGINATION
*/

export const updatePagination = (currentPath, currentPage) => ({ type: 'UPDATE_PAGINATION', currentPath, currentPage });

/*
	FAVOURITES
*/

export const toggleFavourite = (productId, currentPath) => (dispatch, getState) => {
	const { favourites, setup } = getState().environment;
	const product = getState().productCache[setup.market][setup.pricelist].products[productId];

	if (favourites.indexOf(productId) === -1 && typeof window.dataLayer !== 'undefined') {
		window.dataLayer.push({
			event: 'AddToWishlist',
			values: {
				value: product.price.priceAsNumber,
				currency: setup.countries[setup.country].currency,
				content_name: product.name,
				content_category: currentPath,
				content_ids: [`1/${setup.country.toLowerCase()}-${product.id}-s`],
			},
		});
	}
	return dispatch({ type: 'TOGGLE_FAVOURITE', productId });
};

/*
	LANGUAGE
*/

export const changeLanguage = (language) => ({ type: CHANGE_LANGUAGE, language });

/*
	LIST
*/

export const setSort = (sortType) => ({ type: INDEX_SORT, sortType });

// Update CMS with users.
export const retrieveListing = (path) => (dispatch) => (
	fetchData(path).then((data) => {
		const index = [];
		data.content.forEach((page) => {
			const { uri } = page.meta.default;
			dispatch({ type: 'PAGE_DATA', data: { content: page, paths: { en: uri } }, page: uri });

			let extractedProjectMeta = {};
			let extractedEditorialLink = [];
			page.sections.forEach((origSection) => {
				const section = deepClone(origSection);
				const template = Object.keys(section)[0];
				if (template === 'acfEditorialLink') extractedEditorialLink.push(deepClone(section));
				if (template === 'acfProjectMeta') extractedProjectMeta = deepClone(section);
			}, []);

			index[index.length] = {
				...page.meta.default,
				...extractedProjectMeta,
				editorialLinks: extractedEditorialLink,
			};
		});

		index.sort((a, b) => {
			const aOrder = a.order || 100;
			const bOrder = b.order || 100;
			if (aOrder === bOrder) {
				return b.uri.localeCompare(a.uri);
			}
			return bOrder > aOrder ? 1 : -1;
		});

		dispatch({ type: 'INDEX', index });
		return data;
	}).catch((err) => console.log(err))
);
